type FaceTecSDKType = typeof import("src/assets/core-sdk/FaceTecSDK.js/FaceTecSDK")["FaceTecSDK"];

declare global {
    interface Window {
        FaceTecSDK?: FaceTecSDKType;
    }
}

// FaceTec is loaded as a global script via angular.json.
export const FaceTecSDK = window.FaceTecSDK as FaceTecSDKType;
